"use strict";

(function (global) {
  
  	/**
  	 * Генераторы модальных окон.
     *
  	 * @namespace WebAccess.components.dialogs
     * @since 5.0.0.4000 
     *
     * @example
     * // Создать и показать новое диалоговое окно.
     * var dialog = new WebAccess.components.dialogs.BaseDialog();
     *     dialog.show();
     * // Создать и показать диалог множественного выбора.
     * var multiSelectDialog = new WebAccess.components.dialogs.BaseMultiSelect([],[]);
     *     multiSelectDialog.show();
  	 */

      global.components.dialogs = {};

     /**
     * Диалоговое окно "Вы уверены что хотите выйти из веб-доступа" [пока в игноре]
     * @function WebAccess.components.dialogs.showLogoutPrompt
     * @ignore
     * @since 5.0.0.7300
     */
      global.components.dialogs.showLogoutPrompt = function () {
        var exit = function (message) {
          if ($("#ExitForm").length === 0)
            ConfirmDialogNew({ text: message, width: 400, height: 'auto' }, logout);
        };
        exit(L('CONFIRM_EXIT'));
        return global.components.dialogs;
      };
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//    

      /**
       * Диалоговое окно "Вы уверены что хотите выйти из веб-доступа" [пока в игноре]
       * @function WebAccess.components.dialogs.showLogoutPrompt 
       * @ignore
       * @since 5.0.0.7300
       */
      global.components.dialogs.showReportParams = function (reportName, id, refcode) {
        ShowReportParams(reportName, id, refcode);
      };

      /**
       * Генераторы контекстных меню.
       *
       * @namespace WebAccess.components.menus   
       * @since 5.0.0.4000
       */
      global.components.menus = {};
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

      /**
       * Генераторы форм и прочих элементов ввода.
       *
       * @namespace WebAccess.components.forms  
       * @since 5.0.0.4000
       */
      global.components.forms = {};
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

      /**
       * Генераторы контролов реквизитов.
       *
       * @since 5.0.0.4000
       * @namespace WebAccess.components.forms.requisites
       */
      global.components.forms.requisites = {};
     //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Обертки для элементов страниц.
     *
     * @namespace WebAccess.components.wrappers
     * @since 5.0.0.4011
     */
    global.components.wrappers = {};
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  

    /**
     * Обертки для таблиц – оберток детальных разделов набора данных. 
     * @since 5.0.0.4011
     * @namespace WebAccess.components.wrappers.details
     */
    global.components.wrappers.details = {};
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Обертки для элементов форм.
     * @since 5.0.0.4011
     * @namespace WebAccess.components.wrappers.form
     */
    global.components.wrappers.form = {};
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Обертки для дерева папок
    * @since 5.2.0.1600
    * @namespace WebAccess.components.wrappers.folderTree
    */
    global.components.wrappers.folderTree = {};

    /**
     * Обертки для существующих реквизитов.
     * @since 5.0.0.7100
     * @namespace WebAccess.components.wrappers.form.requisites
     */
    global.components.wrappers.form.requisites = {};
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Обертки для существующих реквизитов.
     * @since 5.0.0.7100
     * @private
     * @namespace WebAccess.components.wrappers.form.requisites._details
     */
    global.components.wrappers.form.requisites._details = {};

    /**
     * Обертки для списка объектов.
     * @since 5.0.0.4011
     * @namespace WebAccess.components.wrappers.objectList
     */
    global.components.wrappers.objectList = {};

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    /**
     * Обертки для элементов боковой панели страницы.
     * @since 5.0.0.4011
     * @namespace WebAccess.components.wrappers.sideBar
     */
    global.components.wrappers.sideBar = {};

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Обертки для элементов ленты.
     * @since 5.0.0.4011
     * @namespace WebAccess.components.wrappers.toolBar
     */
    global.components.wrappers.toolBar = {};
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Уведомления.
     * @since 5.0.0.4305
     * @namespace WebAccess.components.notifications
     */
    global.components.notifications = global.components.NTF = {};    
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

   /**
   * Обертки для элементов страниц.
   * @since 5.2.0.1100
   * @namespace WebAccess.components.dataViews 
   */
    global.components.dataViews = global.components.DV = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Обертки для элементов страниц.
   * @since 5.2.0.1100
   * @namespace WebAccess.components.dataViews.gridPlugins 
   */
    global.components.dataViews.gridPlugins = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Обертки для элементов страниц.
   * @since 5.2.0.1100
   * @private
   * @namespace WebAccess.components.dataViews.gridPlugins._controls 
   */
    global.components.dataViews.gridPlugins._controls = {};

  /**
   * Обертки для элементов страниц.
   * @since 5.2.0.1100
   * @private
   * @namespace WebAccess.components.dataViews.gridPlugins._editors 
   */
   global.components.dataViews.gridPlugins._editors = {};

  /**
   * Обертки для элементов страниц.
   * @since 5.2.0.1100
   * @private
   * @namespace WebAccess.components.dataViews.gridPlugins._controls.selectList
   */
    global.components.dataViews.gridPlugins._controls.selectList = {
      passEventToContainer: function (element, event) {
        var jEl = $(element);
        var params = [jEl.is(":checked"), jEl.val(), jEl.text(), jEl.data('type')];
        jEl.parents('.container').trigger(event, params);
        return true;
      },

      SPECIAL_VALUE: {
        ALL: 'ALL',
        BLANK: 'BLANK',
        NOBLANK: 'NOBLANK'
      },

      DATE_SPECIAL_VALUE: {
        YESTERDAY: 'YESTERDAY',
        TODAY: 'TODAY',
        TOMORROW: 'TOMORROW',
        THIS_WEEK: 'THIS_WEEK',
        THIS_MONTH: 'THIS_MONTH',
        THIS_YEAR: 'THIS_YEAR'
      }
    };
    

})(window.WebAccess);